import { Controller } from "@hotwired/stimulus"

// Character counter controller pour compteur de caractères en temps réel
// Usage:
//   <div data-controller="character-counter">
//     <textarea data-character-counter-target="value"
//               data-action="input->character-counter#update"
//               maxlength="1000"></textarea>
//     <div data-character-counter-target="counter">
//       <span data-character-counter-target="count">0</span> / 1000
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["value", "counter", "count"]

  connect() {
    if (this.hasValueTarget) {
      this.update()
    }
  }

  update() {
    if (!this.hasValueTarget) return

    const length = this.valueTarget.value.length
    const maxLength = this.valueTarget.maxLength || 1000

    if (this.hasCountTarget) {
      this.countTarget.textContent = length
    } else if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${length} caractère${length > 1 ? 's' : ''}`
    }

    if (this.hasCounterTarget) {
      this.updateCounterStyle(length, maxLength)
    }
  }

  updateCounterStyle(length, maxLength) {
    const WARNING_THRESHOLD = 0.7
    const DANGER_THRESHOLD = 0.9

    if (length > maxLength * DANGER_THRESHOLD) {
      this.counterTarget.classList.add('text-red-600', 'font-bold')
      this.counterTarget.classList.remove('text-gray-600', 'text-orange-600')
    } else if (length > maxLength * WARNING_THRESHOLD) {
      this.counterTarget.classList.add('text-orange-600')
      this.counterTarget.classList.remove('text-gray-600', 'text-red-600', 'font-bold')
    } else {
      this.counterTarget.classList.add('text-gray-600')
      this.counterTarget.classList.remove('text-orange-600', 'text-red-600', 'font-bold')
    }
  }

  // Alias pour compatibilité
  updateCounter() {
    this.update()
  }
} 